<template>
  <div>
    <el-form>
      <el-form-item label="">
        <el-select v-model="obj.selectedCategoryValue" style="width:120px"> 
          <el-option
            v-for="item in obj.selectCategoryList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
      <el-input v-model="obj.title" placeholder="标题" style="width: 700px;">
      </el-input>
      </el-form-item>
      <el-form-item label="">
      <el-input v-model="obj.imgURL" placeholder="封面" style="width: 700px;">
      </el-input>
      </el-form-item>
      <div class="vue-quill-editor">
        <QuillEditor theme="snow" placeholder="内容" contentType='html' v-model:content="obj.content" :options="obj.options" style='height:600px'/>
      </div>
      <el-form-item label="">
        <el-button type="primary" @click="submit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { http } from "../util/http";
import { ElMessage } from 'element-plus'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@vueup/vue-quill/dist/vue-quill.bubble.css';
export default {
  components: {
    QuillEditor
  },
  setup () {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const store = useStore()
    const router = useRouter()
    const obj = reactive({
      title:'',
      imgURL:'',
      content:'',
      selectCategoryList: [
        {
          value: 'article',
          label: '文章'
        },
        {
          value: 'info',
          label: '资讯'
        },
        {
          value: 'thoughts',
          label: '感想'
        },
        {
          value: 'notice',
          label: '公告'
        },
        {
          value: 'message',
          label: '消息'
        }
      ],
      selectedCategoryValue: 'article',
      options: {
        theme: "snow",
        placeholder: "请输入内容",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
            ['blockquote', 'code-block'], //引用，代码块
            [{ header: 1 }, { header: 2 }], // 几级标题
            [{ list: "ordered" }, { list: "bullet" }], // 有序列表，无序列表
            [{ script: "sub" }, { script: "super" }], // 下角标，上角标
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            //[{ direction: "rtl" }], // 文字输入方向
            [{ size: ["small", false, "large", "huge"] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
            [{ color: [] }, { background: [] }], // 颜色选择
            [{ font: [] }], // 字体
            [{ align: [] }], // 居中
            ["clean"],//清除样式
            // [("link", "image","video")],//控制能上传的内容
          ],
        },
      },
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      // console.log(store.state.user)
      if (store.state.user.authority !== '机构专业版'){
        console.log(store.state.user)
        router.push('/')
      }
      vueEvent.emit('navbarMenuIdxEvent', '9') 
      vueEvent.emit('sidebarMenuIdxEvent', '')
      renderView()
    })

    // 渲染画面
    const renderView = () => {
      requestData()
    }

    // 后台获取数据
    const requestData = () => {
      processData()
    }
    
    // 加工处理数据
    const processData = (res) => {
    }

    // 提交后台
    const submit = () => {
      if (!formCheck()){
        return
      }
      let formData = new FormData()
      formData.append("category", obj.selectedCategoryValue)
      formData.append("title", obj.title)
      formData.append("img_url", obj.imgURL)
      formData.append("content", obj.content)

      let url = `/info`
      if (obj.selectedCategoryValue === 'message'){
        url = `/message`
      }
      http({
        url: url,
        method: 'post',
        data: formData
      }).then((res) => {
        ElMessage.success('提交成功')
        resetView()
      })
    }

    // 表单check
    const formCheck = () => {
      if (obj.selectedCategoryValue === 'article'){
        if (obj.title.trim() === ''){
          ElMessage.error('请输入文章标题')
          return false
        }
        if (obj.imgURL.trim() === ''){
          ElMessage.error('请输入封面图片地址')
          return false
        }
        if (obj.content.trim() === ''){
          ElMessage.error('请输入内容')
          return false
        }
      } else if (obj.selectedCategoryValue === 'message'){
        if (obj.title.trim() === ''){
          ElMessage.error('请输入文章标题')
          return false
        }
        if (obj.content.trim() === ''){
          ElMessage.error('请输入内容')
          return false
        }
      } else {
        if (obj.content.trim() === ''){
          ElMessage.error('请输入内容')
          return false
        }
      }
      return true
    }

    // 重置画面
    const resetView = () => {
      obj.title = ''
      obj.imgURL = ''
      obj.content = '' // 此处清空无效
    }

    return {
      obj,
      store,
      submit
    }
  }
}
</script>
<style lang="scss" scoped>
.vue-quill-editor {
  width: 700px;
}
</style>
